export default __webpack_public_path__ + "static/media/home_footer_machine_icon.46e740f9.svg";